// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__906BQ","headerWrapper":"Header_headerWrapper__IgwhE","logoheader":"Header_logoheader__2ap__","sticky":"Header_sticky__HqgfY"};